import { Component, input, signal } from '@angular/core';
import { MoneyDisplayPipe } from '@core/utils/money-display-pipe';
import {
  BillSplitParticipantSummaryItemResponseDto,
  BillSplitParticipantSummaryResponseDto,
} from '@features/client/models/public-bill-split-models';

@Component({
  selector: 'app-public-bill-split-summary-card',
  standalone: true,
  imports: [MoneyDisplayPipe],
  templateUrl: './public-bill-split-summary-card.html',
})
export class PublicBillSplitSummaryCardComponent {
  currency = input.required<string>();
  participants = input.required<BillSplitParticipantSummaryResponseDto[]>();

  expandedIds = signal<Set<string>>(new Set());

  toggleParticipant(participantId: string): void {
    const next = new Set(this.expandedIds());
    if (next.has(participantId)) {
      next.delete(participantId);
    } else {
      next.add(participantId);
    }
    this.expandedIds.set(next);
  }

  isExpanded(participantId: string): boolean {
    return this.expandedIds().has(participantId);
  }

  getInitial(name: string): string {
    return name?.trim().charAt(0).toUpperCase() || '?';
  }

  getItemConcept(item: BillSplitParticipantSummaryItemResponseDto): string {
    const p = item.percentage || 0;

    if (p >= 99.9) return '';

    if (item.displayMode === 'QUANTITY') {
      if (item.participantQuantity === item.itemTotalQuantity) return '';
      return `${item.participantQuantity}/${item.itemTotalQuantity}`;
    }

    if (item.displayMode === 'PERCENTAGE') {
      if (Math.abs(p - 50) < 0.1) return '1/2';
      if (Math.abs(p - 33.33) < 0.5) return '1/3';
      if (Math.abs(p - 66.66) < 0.5) return '2/3';
      if (Math.abs(p - 25) < 0.1) return '1/4';
      if (Math.abs(p - 75) < 0.1) return '3/4';

      return `${Math.round(p)}%`;
    }

    return '';
  }
}
